import {Moment} from 'moment';
import {ICustomer} from './customer.model';
// import {IUser} from "../../core/user/user.model";
import {IOrderObject} from "./order-object.model";
import {IOrganization} from "./organization.model";
import {IEmployee} from "./employee.model";
import {IContract} from "./contract.model";
import {IProject} from "./project.model";
import {ISalesCycle} from "./salesCycle.model";
import {ISupplier} from "./supplier.model";
import {IProjectItems} from "./project-items.model";

export interface ITransaction {
  id?: number;
  isdeleted?: boolean;
  itemName?: string;
  customer_title?: string;
  customer_id?: any;
  customerId?: any;
  status?: string;
  type?: string;
  description?: string;
  period_duration?: string;
  deadline?: boolean;
  expiratioDate?: Moment;
  action?: string;
  actionStr?: string;
  actionFollow?: string;
  actionDate?: any;
  audience?: string;
  jalaliDate?: string;
  jalaliDate_reminder?: string;
  jalaliDateFollow?: string;
  followupby?: number;
  followupbyS?: string;
  followupbyDate?: Moment;
  followupbyAudience?: string;
  add_auto_for_prj_item?: boolean;
  step?: string;
  priority?: string;
  project_item_str?: any;
  step_number?: any;
  followupbyDescription?: string;
  createby?: number;
  createdBy?: any;
  lastModifiedBy?: any;
  item_number?: any;
  createbyS?: string;
  createDate?: Moment;
  customer?: ICustomer;
  projectItem?: IProjectItems;
  supplier?: ISupplier;
  order?: IOrderObject;
  reminderMe_time?: string;
  reminderMe_type?: string;
  reminderMin?: any;
  reminderMe?: boolean;
  // user_fk?: IUser;
  userId?: any;
  employee_str?: any;
  employee?: IEmployee;
  contract?: IContract;
  project?: IProject;
  salesCycle?: ISalesCycle;
  contract_str?: any;
  project_str?: any;
  salesCycle_str?: any;
  organization?: IOrganization;
  createdDate?: any;
  lastModifiedDate?: any;
  last_modified_date?: any;
  created_date?: any;
  /** Previous follow-up in chain */
  parentId?: number;
  /** Shared root of follow-up chain */
  rootId?: number;
  /** Attached file count (chain API) */
  fileCount?: number;

}

export class Transaction implements ITransaction {
  constructor(public id?: number,
              public itemName?: string,
              public status?: string,
              public type?: string,
              public createdBy?: any,
              public description?: string,
              public period_duration?: string,
              public deadline?: boolean,
              public expiratioDate?: Moment,
              public actionFollow?: string,
              public action?: string,
              public actionStr?: string,
              public reminderMe_time?: string,
              public reminderMe_type?: string,
              public reminderMin?: any,
              public reminderMe?: boolean,
              public actionDate?: Moment,
              public audience?: string,
              public jalaliDate?: string,
              public jalaliDateFollow?: string,
              public followupby?: number,
              public followupbyS?: string,
              public followupbyDate?: Moment,
              public followupbyAudience?: string,
              public step?: string,
              public priority?: string,
              public step_number?: any,
              public followupbyDescription?: string,
              public createby?: number,
              public createbyS?: string,
              public createDate?: Moment,
              public employee?: IEmployee,
              public customer?: ICustomer,
              public orderObject?: IOrderObject,
              public contract?: IContract,
              public project?: IProject,
              public salesCycle?: ISalesCycle,
              public userId?: String,
              public employee_str?: any,
              public contract_str?: any,
              public salseCycle_str?: any,
              public project_str?: any,
              public lastModifiedDate?: any,
              public createdDate?: any,
              public organization?: IOrganization) {
    this.deadline = this.deadline || false;

  }
}
